import * as Viewport from "pixi-viewport";
import { Container } from "pixi.js";
import { EMPTY, fromEvent } from "rxjs";
import { filter, map, shareReplay, startWith } from "rxjs/operators";
var EventsViewport = /** @class */ (function () {
    function EventsViewport() {
        var _this = this;
        this.createViewportEvent$ = function (parent, event, filterFn, fps) {
            if (event === void 0) { event = "moved"; }
            if (filterFn === void 0) { filterFn = function () { return true; }; }
            if (fps === void 0) { fps = 60; }
            var viewport = _this.findViewport(parent);
            if (!viewport) {
                return EMPTY;
            }
            return fromEvent(viewport, event).pipe(startWith(viewport), 
            // .throttleTime(1000 / fps)
            filter(filterFn), shareReplay(), map(function (e) { return (e instanceof Viewport ? e : e.viewport); }));
        };
        this.findViewport = function (parent) {
            if (!(parent instanceof Container)) {
                return undefined;
            }
            var length = parent.children.length;
            var child;
            var viewport;
            for (var i = 0; i < length; i++) {
                child = parent.getChildAt(0);
                if (child instanceof Viewport) {
                    return child;
                }
            }
            for (var i = 0; i < length; i++) {
                child = parent.getChildAt(0);
                viewport = _this.findViewport(child);
                if (viewport) {
                    return viewport;
                }
            }
            return undefined;
        };
    }
    return EventsViewport;
}());
export var eventsViewport = new EventsViewport();



//////////////////
// WEBPACK FOOTER
// ./src/events/eventsViewport.ts
// module id = 1666
// module chunks = 3